var Backbone=require("backbone"),ReadOnly=Backbone.ReadOnly={Model:require("./Model"),Collection:require("./Collection")};module.exports=ReadOnly;